/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
// reactstrap components
import NotificationAlert from "react-notification-alert";
// import Modal from 'react-modal';

import pdfImg from "assets/img/pdf.png";
import {  
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Form,
    Input,
    Row,
    Col  
} from "reactstrap";

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";
let session = {};
let notificationAlert;
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding:'0.25rem',
        width:'85%',
        borderRadius:'15px',
        maxWidth:'1000px',
        fontWeight:'bold'
    }
};

function Mailreg(){
    notificationAlert = React.useRef();
    const history = useHistory();

    const [cropData, setCropData] = useState("#");
    const [cropper, setCropper] = useState();
    const [modalIsOpen, setIsOpen]    = useState(false);
    const [groupF, setGroupF] = useState(0);
    const players = JSON.parse(window.sessionStorage.getItem('players'));
    const [selPlayers, setSelPlayers] = useState([]);
    const [reloadF, setReloadF] = useState(false);

    const [mTitle, setMTitle] = useState('');
    const [mText, setMText] = useState('');
    const [images, setImages] = useState([]);
    const [pDateTimeC, setPDateTimeC] = useState(false);
    const [pDateTime, setPDateTime] = useState(new Date());

    const onGroup = (e, f) => {
        if(f != 0)
            setSelPlayers([]);
        setGroupF(f);
    }

    const onSelectPlayer = (e, id, index) => {
        let v = selPlayers;
        let idx = v.indexOf(id);
        if( idx > -1){
            v.splice(idx, 1);
        }else{
            v.push(id);
        }
        setReloadF(!reloadF);
        setSelPlayers(v);
    }

    const setTitle = (e) => {
        setMTitle(e.target.value);
    }

    const setText = (e) => {
        setMText(e.target.value);
    }

    const handleSubmit = (e) => {
        let v = images;
        // console.log(v);
        let file = null;
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
          files = e.dataTransfer.files;
        } else if (e.target) {
          files = e.target.files;
        }
        if(files.length == 0)
            return;
        const reader = new FileReader();
        reader.onload = () => {
            // setImages((v) => v.push(reader.result));
            if(file.type.indexOf('image') > -1)
                v.push({src:reader.result, name:file.name});
            else if(file.type.indexOf('application/pdf') > -1){
                v.push({src:pdfImg, name:file.name});
            }
            setImages(v);
            setReloadF(!reloadF);
        };
        reader.readAsDataURL(files[0]);
        file = files[0];
        // console.log(files[0]);
    }

    const onSelectImage = (event) => {
        document.getElementById("photo").click();
    }

    const onPDateTimeC = (e) => {
        setPDateTimeC(!pDateTimeC);
    }

    const onSetPDateTime = (e) => {
        setPDateTime(e.target.value);
    }

    const onFileOver = (e) => {
        console.log(e);
    }

    const onSendMail = (e) => {

    }

    useEffect(() => {

        // axios.get(URL_API+"getPlayersInfo", {
        //     params: {
                
        //     }
        // })
        // .then(function (response) {

        // }); 
        console.log(selPlayers);
    }, [reloadF]);

    return (
        <>
            <div className="px-0 pb-0 mt-3">
                <NotificationAlert ref={notificationAlert} />
                <div className="row px-0 mx-1 border-bottom pb-2 mb-2">
                    <div className="col-12 text-left">
                        <label className="my-1">宛先タイプ</label>
                        <div className="col-12 d-flex justify-content-between align-items-center px-0">
                            <label className="d-flex align-items-center">
                                <Input className="mr-1 ml-0 mt-0" name="group" checked={groupF == 0 ? true : false} type="radio" onChange={(e) => onGroup(e, 0)} style={{position:'unset'}}/>
                                個人宛
                            </label>
                            <label className="d-flex align-items-center">
                                <Input className="mr-1 ml-0 mt-0" name="group" checked={groupF == 1 ? true : false} type="radio" onChange={(e) => onGroup(e, 1)} style={{position:'unset'}}/>
                                全員宛
                            </label>
                            <label className="d-flex align-items-center">
                                <Input className="mr-1 ml-0 mt-0" name="group" checked={groupF == 2 ? true : false} type="radio" onChange={(e) => onGroup(e, 2)} style={{position:'unset'}}/>
                                親宛
                            </label>
                            <label className="d-flex align-items-center">
                                <Input className="mr-1 ml-0 mt-0" name="group" checked={groupF == 3 ? true : false} type="radio" onChange={(e) => onGroup(e, 3)} style={{position:'unset'}}/>
                                選手宛
                            </label>
                            <label className="d-flex align-items-center">
                                <Input className="mr-1 ml-0 mt-0" name="group" checked={groupF == 4 ? true : false} type="radio" onChange={(e) => onGroup(e, 4)} style={{position:'unset'}}/>
                                コーチ宛
                            </label>
                        </div>
                    </div>                    
                    <div className="row col-12 mx-0" style={{overflow:'auto', maxHeight:'300px'}}>
                    {
                        groupF == 0 && (
                            players.map((player, idx) => 
                                <span value={idx} className={"mr-1 mb-2 p-2 " + (selPlayers.indexOf(player.id) > -1 ? 'selectedPlayer' : 'unSelectedPlayer')} key={idx} onClick={(e) => onSelectPlayer(e, player.id, idx)}>
                                    <img className="mr-1" src={player.profile_photo_path ? "https://xs458763.xsrv.jp/uploads/"+player.profile_photo_path : require("assets/img/mike.png").default} style={{width:'17px', height:'17px'}} /> 
                                    {player.name}
                                </span>
                            )
                        )
                    }
                    </div>
                </div>
                <div className="col-12 text-left border-bottom pb-2 mb-2">
                    <FormGroup>
                        <label>タイトル</label>
                        <Input type="text" onChange={setTitle} value={mTitle == null ? '' : mTitle}/>
                    </FormGroup>
                </div>
                <div className="col-12 text-left border-bottom pb-2 mb-2">
                    <FormGroup>
                        <label>本文</label>
                        <div className="col-12 px-0">
                            <textarea className="col-12 p-2" onChange={setText} value={mText == null ? '' : mText} style={{resize:'none', height:'200px'}}>
                                {mText == null ? '' : mText}
                            </textarea>
                        </div>
                    </FormGroup>
                </div>
                <div className="col-12 text-left border-bottom pb-2 mb-2">
                    <FormGroup>
                        <label onClick={onSelectImage}>
                            <i className="fas fa-file mr-1"></i>
                            ファイルを添付する
                        </label>
                        <input type="file" id="photo" style={{display:'none'}} onChange={handleSubmit}/>
                    </FormGroup>
                    <div className="col-12 py-1 px-0 d-flex" style={{flexWrap:'wrap'}}>
                    {
                        images.length > 0 && (
                            images.map((img, idx) =>
                                <div key={idx} className="px-1 mail_file mb-2">
                                    <div className=" border mx-0 w-100">
                                        <div className="p-1 w-100 mail_file_src">
                                            <img className="w-100" src={img.src}/>
                                        </div>
                                        <div className="w-100 mail_file_name_div d-flex justify-content-between">
                                            <span title={img.name} className="mail_file_name" style={{fontSize:'20px'}}>
                                                {img.name}
                                            </span> 
                                            <div className="p-1 d-flex justify-content-between align-items-center">
                                                <i className="fa fa-trash-alt pointer" style={{fontSize: '18px', color: '#999'}}></i>
                                            </div>                                       
                                        </div>
                                    </div>
                                </div>
                            )
                        )
                    }
                    </div>
                </div>
                <div className="col-12 text-left border-bottom pb-2 mb-2">
                    <FormGroup>
                        <label>配信日時</label>
                        <div className="col-12 d-flex px-0 align-items-center">
                            <label className="d-flex align-items-center">
                                <Input className="mr-1 mt-0 ml-0" type="checkbox" checked={pDateTimeC} onChange={onPDateTimeC} style={{position:'unset'}}/>
                                配信日時を指定する
                            </label>  
                        </div>                      
                    </FormGroup>
                    {
                        pDateTimeC == true && (
                            <div className="col-12 py-1 px-0">
                                <Input type="datetime-local" value={pDateTime} onChange={onSetPDateTime} />
                            </div>
                        )
                    }
                </div>
                <div className="col-12">
                    <FormGroup className="mb-0">
                        <input type="button" name="user" value="送信" className="btn-round btn btn-primary" onClick={onSendMail}/>
                    </FormGroup>
                </div>
            </div>
        </>
    )
}

export default Mailreg;